import React from 'react'
import PropTypes from 'prop-types'

import ContentModal from '../../../common/ContentModal'
import ContentModalCloseButton from '../../../common/ContentModalCloseButton'

import HintBody from './HintBody'
import HintSelectionList from './HintSelectionList'

import './style.less'

function LessonHintModal(props) {
  const { hints, selectedHintIndex, onSelectHint, onClose } = props
  const hint = selectedHintIndex >= 0 ? hints[selectedHintIndex] : null
  return (
    <ContentModal id="lesson-hint-modal" onClose={onClose}>
      <ContentModalCloseButton onClick={onClose} />
      <div style={{ padding: 40 }}>
        {hint ? (
          <HintBody
            title={hint.title}
            markdown={hint.markdown}
            onClickBack={hints.length <= 1 ? null : () => onSelectHint(-1)}
          />
        ) : (
          <HintSelectionList
            hints={hints}
            onSelectHint={onSelectHint}
          />
        )}
      </div>
    </ContentModal>
  )
}
LessonHintModal.propTypes = {
  hints: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    markdown: PropTypes.string.isRequired,
  })).isRequired,
  selectedHintIndex: PropTypes.number.isRequired,
  onSelectHint: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
}

export default LessonHintModal
